import React, { Fragment, ReactElement } from 'react';
import LinkPlain from '../link-plain/link-plain.component';
import Image from '../image/image.component';
import MainService from '../../services/main-service';
import useAndroidPlatform from '../../hooks/use-android-platform';
import useIosPlatform from '../../hooks/use-ios-platform';
import useMobileDevice from '../../hooks/use-mobile-device';
import useStylesMobileAppLink from './mobile-app-link.styles';

const MobileAppLink: ReactMemoComponent = React.memo((): ReactElement => {
  const STATIC_FILE_PATH_IMAGE_GOOGLE_PLAY_STORE_BUTTON: string = '/images/google-play-store-button.png';
  const STATIC_FILE_PATH_IMAGE_APPLE_APP_STORE_BUTTON: string = '/images/apple-app-store-button.png';

  const { classes } = useStylesMobileAppLink();
  const isMobileDevice: boolean = useMobileDevice();
  const isAndroidPlatform: boolean = useAndroidPlatform();
  const isIosPlatform: boolean = useIosPlatform();

  const isMobileApp: boolean = !!MainService.IS_MOBILE_APP;
  const googlePlayStoreLink: string | undefined = MainService.GOOGLE_PLAY_STORE_LINK;
  const appleAppStoreLink: string | undefined = MainService.APPLE_APP_STORE_LINK;
  const googlePlayStoreText: string = 'Download Android App on Google Play Store';
  const appleAppStoreText: string = 'Download iOS App on Apple App Store';

  return (
    <Fragment>
      {
        !isMobileApp && isMobileDevice && (
          <Fragment>
            {
              isAndroidPlatform && googlePlayStoreLink && (
                <LinkPlain withNewWindow link={googlePlayStoreLink}>
                  <Image
                    isDefault
                    text={googlePlayStoreText}
                    link={STATIC_FILE_PATH_IMAGE_GOOGLE_PLAY_STORE_BUTTON}
                    className={classes.mobileAppLinkImage}
                  />
                </LinkPlain>
              )
            }
            {
              isIosPlatform && appleAppStoreLink && (
                <LinkPlain withNewWindow link={appleAppStoreLink}>
                  <Image
                    isDefault
                    text={appleAppStoreText}
                    link={STATIC_FILE_PATH_IMAGE_APPLE_APP_STORE_BUTTON}
                    className={classes.mobileAppLinkImage}
                  />
                </LinkPlain>
              )
            }
          </Fragment>
        )
      }
    </Fragment>
  );
});

export default MobileAppLink;
